import {ErrorCode, ErrorResponse, singleCodeFromResponse} from "../../../tools/error-response";
import {LocalizationStrings} from "../../../i18n/i18n-model";

const messages = new Map<ErrorCode, keyof LocalizationStrings>()
.set(ErrorCode.ECG_SAMPLES_DOCUMENT_MISSING, "finishAnalysisFailedBecauseSamplesDocumentMissing")
.set(ErrorCode.FILE_SIZE_INVALID, "finishAnalysisFailedBecauseSamplesDocumentSizeInvalid")
;

export function resolveFinishAnalysisErrorMessage(errorResponse: ErrorResponse) {
  return messages.get(singleCodeFromResponse(errorResponse)) || "analysisMessageFinishAnalysisFailed";
}
